export const AUTH_RETURN_URL_STORAGE_KEY = 'AUTH_RETURN_URL' as const;
export const AUTH_RETURN_URL_TTL_MS = 5 * 60 * 1000; // 5 minutes to cover magic-link flows
